// DirectDebit Enums - matching backend enum names
export const DirectDebitPaymentStatus = {
	Pending: 'Pending',
	UnderProcess: 'UnderProcess',
	RepresentmentPending: 'RepresentmentPending',
	Error: 'Error',
	Rejected: 'Rejected',
	Accepted: 'Accepted',
};

export const DirectDebitDdaStatus = {
	Pending: 'Pending',
	Denied: 'Denied',
	RequestExpired: 'RequestExpired',
	PendingBankSubmission: 'PendingBankSubmission',
	PendingBankApproval: 'PendingBankApproval',
	Error: 'Error',
	Rejected: 'Rejected',
	Active: 'Active',
	Suspended: 'Suspended',
	Cancelled: 'Cancelled',
	Expired: 'Expired',
};

export const DirectDebitCancellationStatus = {
	Pending: 'Pending',
	Accepted: 'Accepted',
	Rejected: 'Rejected',
	Error: 'Error',
};

export const DirectDebitPaymentMethod = {
	BankAccount: 'BankAccount',
	CreditCard: 'CreditCard',
};

export const DirectDebitPaymentBatchStatus = {
	Uploaded: 'Uploaded',
	Processing: 'Processing',
	Processed: 'Processed',
	Failed: 'Failed',
};
